const _0x396ffc = _0x7c9d;
function _0x2afa() {
  const _0x3e7f7d = [
    "forEach",
    ",width=640,height=440,toolbar=0",
    "30jYHWuB",
    "4NBEohJ",
    "348NxTHDo",
    "width",
    "mywin",
    "11666736imkOtY",
    "589906fTuBtY",
    "3193712iwwLLn",
    "left=",
    "click",
    "open",
    "48485jdqKzj",
    "9SvsbDo",
    "324203SCYIuh",
    "querySelectorAll",
    ",top=",
    ".social",
    "13TPqkGo",
    "href",
    "4vqWWRS",
    "1471653JMImgS",
    "addEventListener",
    "getAttribute",
    "preventDefault",
    "setupEventListeners",
    "container",
    "7496734ZsEqVf",
    "undefined",
  ];
  _0x2afa = function () {
    return _0x3e7f7d;
  };
  return _0x2afa();
}
(function (_0x3ee377, _0x4f1213) {
  const _0x51b812 = _0x7c9d,
    _0x1c82ed = _0x3ee377();
  while (!![]) {
    try {
      const _0x36ae78 =
        (parseInt(_0x51b812(0x165)) / 0x1) * (parseInt(_0x51b812(0x160)) / 0x2) +
        (-parseInt(_0x51b812(0x155)) / 0x3) * (parseInt(_0x51b812(0x154)) / 0x4) +
        (parseInt(_0x51b812(0x16a)) / 0x5) * (parseInt(_0x51b812(0x161)) / 0x6) +
        -parseInt(_0x51b812(0x15b)) / 0x7 +
        (-parseInt(_0x51b812(0x166)) / 0x8) * (parseInt(_0x51b812(0x16b)) / 0x9) +
        (-parseInt(_0x51b812(0x15f)) / 0xa) * (-parseInt(_0x51b812(0x14e)) / 0xb) +
        (parseInt(_0x51b812(0x164)) / 0xc) * (parseInt(_0x51b812(0x152)) / 0xd);
      if (_0x36ae78 === _0x4f1213) break;
      else _0x1c82ed["push"](_0x1c82ed["shift"]());
    } catch (_0x2a36f9) {
      _0x1c82ed["push"](_0x1c82ed["shift"]());
    }
  }
})(_0x2afa, 0xcd9ae);
function _0x7c9d(_0x2cc78b, _0x30d99e) {
  const _0x2afa24 = _0x2afa();
  return (
    (_0x7c9d = function (_0x7c9d76, _0x59d1f0) {
      _0x7c9d76 = _0x7c9d76 - 0x14e;
      let _0x4d58d = _0x2afa24[_0x7c9d76];
      return _0x4d58d;
    }),
    _0x7c9d(_0x2cc78b, _0x30d99e)
  );
}
class SocialShare {
  constructor() {
    const _0x142943 = _0x7c9d;
    (this[_0x142943(0x15a)] = document["querySelector"](".share-article")),
      (this["links"] = document[_0x142943(0x14f)](_0x142943(0x151))),
      this[_0x142943(0x159)]();
  }
  [_0x396ffc(0x159)]() {
    const _0x39b159 = _0x396ffc;
    this["links"][_0x39b159(0x15d)]((_0x33d7bf) => {
      const _0x216a7c = _0x39b159;
      _0x33d7bf[_0x216a7c(0x156)](_0x216a7c(0x168), (_0x2a96e9) => {
        const _0x222d60 = _0x216a7c;
        let _0x2206be = screen[_0x222d60(0x162)] / 0x2 - 0x280 / 0x2,
          _0x5c1697 = screen["height"] / 0x2 - 0x1b8 / 0x2 - 0x64;
        window[_0x222d60(0x169)](
          _0x33d7bf[_0x222d60(0x157)](_0x222d60(0x153)),
          _0x222d60(0x163),
          _0x222d60(0x167) + _0x2206be + _0x222d60(0x150) + _0x5c1697 + _0x222d60(0x15e),
        ),
          _0x2a96e9[_0x222d60(0x158)]();
      });
    });
  }
}
window[_0x396ffc(0x156)]("load", () => {
  const _0x45be7b = _0x396ffc;
  typeof SocialShare !== _0x45be7b(0x15c) && new SocialShare();
});
